import { AyudaSec as S, AyudaCopiable as Copiable } from './ayuda-partes.jsx'

/** Cómo conectar clientes MCP. Vive en la ayuda navegable; antes era la página /conectar. */
export function AyudaConexion() {
  const origen = window.location.origin
  const urlMcp = `${origen}/mcp`

  return (
    <>
      <p>
        La consola sirve un servidor MCP: crear proyectos, escribir ficheros (cada escritura
        despliega sola), funciones, variables, logs y métricas desde tu asistente — con{' '}
        <strong>tus</strong> permisos, recalculados en cada uso. El token dura 30 días, todo queda
        auditado, y un admin lo revoca en <code>Admin → Sesiones</code>.
      </p>

      <S titulo="Claude Code (terminal)">
        <Copiable texto={`claude mcp add --transport http consola ${urlMcp}`} />
        <p>La autorización salta al primer uso: login de GitLab y autorizar.</p>
      </S>

      <S titulo="Claude Desktop y claude.ai">
        <p><strong>Ajustes → Conectores → Añadir conector personalizado</strong>, con esta URL:</p>
        <Copiable texto={urlMcp} />
        <p>
          Visto en la práctica: si Desktop bloquea las llamadas, añade el dominio de la consola en{' '}
          <strong>Ajustes → Código y comandos → dominios permitidos</strong>.
        </p>
        <p>
          El caso estrella: «crea una app» — te preguntará <strong>nombre</strong> y{' '}
          <strong>slug</strong> (será el subdominio), creará el repo con una plantilla que ya
          despliega, y podrás iterar <strong>sin git ni tokens</strong>.
        </p>
      </S>

      <S titulo="Otros clientes (ChatGPT, Cursor, VS Code…)">
        <p>Vale cualquier cliente MCP por <strong>Streamable HTTP con OAuth</strong>:</p>
        <Copiable texto={urlMcp} />
        <p>
          Autorización: OAuth 2.1 con PKCE y registro dinámico. Descubrimiento:{' '}
          <code>{origen}/.well-known/oauth-authorization-server</code>.
        </p>
        <p>
          <strong>ChatGPT</strong>: Ajustes → Conectores (modo desarrollador). <strong>Cursor</strong>:{' '}
          <code>.cursor/mcp.json</code>. <strong>VS Code</strong>: <code>MCP: Add Server</code> → HTTP.
        </p>
        <p className="ayuda-nota">
          Lo probado en real es Claude Code y Desktop; el resto implementa el mismo estándar y los
          fallos OAuth salen con su motivo en el registro.
        </p>
      </S>

      <S titulo="Qué puede hacer">
        <p>
          17 herramientas: proyectos (crear con repo y plantilla), ficheros del repositorio,
          desplegar, logs, funciones completas, variables, esquema y métricas. Fuera a propósito:
          borrar proyectos, borrar tablas y SQL arbitrario.
        </p>
      </S>
    </>
  )
}
